import React, { FC } from 'react';
import { Grid, IconButton, TableRow, TableCell } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { FeedKey, Group } from 'api';
import { CustomSVG, FollowToggle, ToggleButton } from 'components';
import { useCurrentUser } from 'hooks';
import { isGroupOwnerOrModerator } from 'features/groups/helpers';

import ImageCell from '../GroupCells/Image';
import TitleCell from '../GroupCells/Title';
import MembersCell from '../GroupCells/Members';
import { generateLink } from 'Links';

interface IProps {
  group: Group;
}

interface IPropsEnhanced extends IProps, WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    follow: {
      paddingLeft: theme.spacing(1),
    },
    row: {
      '&:nth-child(even)': {
        backgroundColor: theme.palette.common.white,
        border: `1px solid ${theme.custom.palette.grey5}`,
      },
    },
  });

const ClientRow: FC<IPropsEnhanced> = ({ classes, group }) => {
  const currentUser = useCurrentUser();
  const canEdit = isGroupOwnerOrModerator(currentUser, group.id);

  function renderFollow() {
    return (
      <div className={classes.follow}>
        <FollowToggle source={group} type={FeedKey.Group}>
          {({ disableToggle, isFollowing, loading, onClick }) =>
            !disableToggle && (
              <ToggleButton disabled={loading} selected={isFollowing} onClick={onClick} />
            )
          }
        </FollowToggle>
      </div>
    );
  }

  function renderEdit() {
    return (
      <IconButton component={generateLink(`/group/${group.id}/edit`)}>
        <CustomSVG size={30} name="pencil" />
      </IconButton>
    );
  }

  function renderActions() {
    return canEdit ? renderEdit() : renderFollow();
  }

  return (
    <TableRow classes={{ root: classes.row }} key={group.id}>
      <TableCell>
        <Grid container alignItems="center" wrap="nowrap" spacing={2}>
          <ImageCell group={group} />
          <TitleCell group={group} />
        </Grid>
      </TableCell>
      <TableCell align="center">
        <MembersCell group={group} />
      </TableCell>
      <TableCell>{renderActions()}</TableCell>
    </TableRow>
  );
};

export default withStyles(styles)(ClientRow);
